export default Object.freeze({
    BULK_SAMPLE: 1,
    SWAB: 2,
    SOIL: 3,
    XRF: 5,
    LABORATORY_RESULT: 6,
    NULL: 7,
});